/* eslint-disable no-fallthrough */
import { Auth } from '@aws-amplify/auth';

async function getUserPermissions() {
  const user = await Auth.currentAuthenticatedUser();
  const userGroups = user.signInUserSession.accessToken.payload['cognito:groups'];
  let userPermissions = {};
  userGroups
    ?.forEach((userGroup) => {
      let [collection, authLevel] = userGroup.split('/');
      // HACK: handle SSO auth levels
      if (userGroup === 'us-west-2_kcIOWChT1_CHANEL') {
        collection = 'chanel';
        authLevel = 'editor';
      };
      let permissions = {
        create: false,
        view: false,
        update: false,
        delete: false,
        publish: false,
      };
      switch (authLevel) {
        case 'admin':
          permissions.delete = true;
        case 'manager':
          permissions.publish = true;
        case 'editor':
          permissions.create = true;
          permissions.update = true;
          permissions.view = true;
        case 'reviewer':
          permissions.view = true;
        default:
          break;
      }
      userPermissions[collection] = permissions;
    });
  return userPermissions;
}

export default getUserPermissions;